"use client";

import {
  Field,
  LinkField,
  Text,
  withDatasourceCheck,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { Link } from "@repo/next-utils/router";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Box from "@repo/ui/box";
import * as Flex from "@repo/ui/flex";
import {
  TYPOGRAPHY_LINK2,
  TYPOGRAPHY_BODY2_BOLD,
} from "../../../../../../../apps/topshop/theme/topshop-2/typography/typography-constants";
import styles from "./get-in-touch.module.css";

export type ContactUsProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    buttonLink: LinkField;
    buttonText: Field<string>;
  };
  isAside?: boolean;
};

const ContactUs = (props: ContactUsProps): JSX.Element => {
  return (
    <Box.Box width="100%">
      <Flex.Container
        column
        gap="2xs"
        className={clsx(
          styles.getInTouchContainer,
          props.isAside && styles.isAside,
        )}
      >
        <Text
          field={props.fields.heading}
          tag="h2"
          className={clsx(TYPOGRAPHY_BODY2_BOLD)}
        />
        <Link
          href={props.fields.buttonLink?.value.href as string}
          className={clsx(styles.getInTouchButtonLink, TYPOGRAPHY_LINK2)}
        >
          <Text field={props.fields.buttonText} />
        </Link>
      </Flex.Container>
    </Box.Box>
  );
};

export default withDatasourceCheck()<ContactUsProps>(ContactUs);
